module.exports = __webpack_public_path__ + "img/logo-dark.45d41145.png";